import cx from 'classnames';
import { CSSProperties } from 'react';

import { ValidChildElement } from '../../types/browser-types';
import styles from './index.css';

/**
  The paddingSize enum values are used to dynamically access styles.
  When changing these or adding new ones, make sure to update the index.css file, located at the root of this component.
  Otherwise, the styles will not be applied correctly or the site will break.
*/
export enum PaddingSize {
  SMALL = 'Small',
  MEDIUM = 'Medium',
  LARGE = 'Large',
}

interface Props {
  children: ValidChildElement;
  sx?: CSSProperties;
  verticalMarginPx?: number;
  paddingSize?: PaddingSize;
}

export default function Card({ children, sx = {}, verticalMarginPx = 10, paddingSize = PaddingSize.MEDIUM }: Props) {
  const padding = `padding${paddingSize}`;
  return (
    <div style={{ paddingBottom: verticalMarginPx, paddingTop: verticalMarginPx }}>
      <div className={cx(styles.card, styles[padding])} style={sx}>
        {children}
      </div>
    </div>
  );
}
